module.exports = __webpack_public_path__ + "img/header-weddingRingsPalladium@2x.1dfa597.webp";